
function insertString(str, index, value) {
  return str.substr(0, index) + value + str.substr(index);
}

function formatUUID(uuid: string): string {
  if (uuid.length !== 32) {
    console.error(`formatUUID: invalid uuid length=${uuid.length}`, uuid);
    return uuid;
  }

  let _uuid = insertString(uuid, 8, '-')
  _uuid = insertString(_uuid, 13, '-')
  _uuid = insertString(_uuid, 18, '-')
  _uuid = insertString(_uuid, 23, '-')

  return _uuid
}

function digitToHex(digit: number): string {
  const hex = digit.toString(16);
  return hex.length < 2 ? '0' + hex : hex;
}

export function uint8ArrayToUuid(uint8Array?: Uint8Array | null): string {
  if (!uint8Array) {
    return '';
  }

  let binary = '';
  let i = 0;
  const len = uint8Array.byteLength;
  for (; i < len; i++) {
    binary += digitToHex(uint8Array[i]);
  }

  if (binary.length !== 32) {
    console.error(`uint8ArrayToUuid: invalid uuid length=${binary.length} byteLength=${len}`, binary);
  }

  return formatUUID(binary);
}

export default uint8ArrayToUuid;
